import * as ActionTypes from './actions';
import update from 'immutability-helper';

const initialState = {
	initializing: true,
	isAuthenticated: false,
	errors: [],
	accessToken: '',
	refreshToken: '',
	passwordResetEmail: '',
	currentUser: {}
};

const auth = (state = initialState, action) => {
	switch (action.type) {
		case ActionTypes.REFRESH_TOKEN_REQUEST:
			if (action.payload.initializing) {
				return update(state, {
					initializing: { $set: true }
				});
			}
			return state;
		case ActionTypes.LOGIN_FAILURE:
			return update(state, {
				isAuthenticated: { $set: false },
				errors: { $set: [action.payload.error] },
				currentUser: { $set: {} }
			});
		case ActionTypes.REFRESH_TOKEN_FAILURE:
			return update(state, {
				initializing: { $set: false },
				isAuthenticated: { $set: false },
				errors: { $set: [action.payload.error] },
				currentUser: { $set: {} }
			});
		case ActionTypes.LOGIN_SUCCESS:
			return update(state, {
				isAuthenticated: { $set: true },
				accessToken: { $set: action.payload.accessToken },
				refreshToken: { $set: action.payload.refreshToken }
			});
		case ActionTypes.REFRESH_TOKEN_SUCCESS:
			return update(state, {
				initializing: { $set: false },
				isAuthenticated: { $set: true },
				accessToken: { $set: action.payload.accessToken },
				refreshToken: { $set: action.payload.refreshToken }
			});
		case ActionTypes.CURRENT_USER_SUCCESS:
			return update(state, {
				currentUser: { $set: action.payload }
			});
		case ActionTypes.FORGOTTEN_PASSWORD_REQUEST:
			return update(state, {
				passwordResetEmail: { $set: '' }
			});
		case ActionTypes.FORGOTTEN_PASSWORD_SUCCESS:
			return update(state, {
				passwordResetEmail: { $set: action.response.email }
			});
		case ActionTypes.LOGOUT:
			return update(state, {
				isAuthenticated: { $set: false },
				accessToken: { $set: '' },
				refreshToken: { $set: '' },
				currentUser: { $set: {} }
			});
		default:
			return state;
	}
};

export default auth;